import { Box, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import LineChart from "../../../components/Dashboard/LineChart";
import AdminLineChart from "./LineChart";
import { useTranslation } from "react-i18next";

function ReportChart({ chartData, isLoading }) {
  const { t } = useTranslation(["report", "common"]);
  return (
    <Paper sx={{ borderRadius: 1, mt: 3 }}>
      <Typography fontSize={"1.25rem"} fontWeight={600} p={2}>
        {t("appointmentsEarningChart")}
      </Typography>

      <Divider />
      {chartData?.length > 0 ? (
        <Box p={2}>
          <AdminLineChart chartData={chartData} />
        </Box>
      ) : (
        chartData?.length === 0 &&
        isLoading === false && (
          <Typography
            variant="h6"
            fontWeight={600}
            my={2}
            textAlign={"center"}
            p={2}
          >
            {t("noDataFound", { ns: "common" })}
          </Typography>
        )
      )}
    </Paper>
  );
}

export default ReportChart;
